<h2  class="titre3 text-center">{{ 'USERS_MANAGEMENT.CONFIRMATION' | translate }}</h2>
<mat-dialog-content>
    <p class="mb-4 text-white">{{ 'USERS_MANAGEMENT.CONFIRM_DEACTIVATE_USERS' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="flex justify-end mt-4">
    <button mat-button (click)="onCancel()"
        class="mr-2 px-4 py-2 btn-secondary-novo">
        {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
    </button>
    <button mat-button color="warn" (click)="onConfirm()"
        class="px-4 py-2 btn-primary-novo">
        {{ 'USERS_MANAGEMENT.DEACTIVATE' | translate }}
    </button>
</mat-dialog-actions>
